import { create } from "zustand";

type Role = "user" | "merchant" | string | null;

interface RoleStore {
  role: Role;
  setRole: (role: Role) => void;
}
/**
 * useAccountStore
 *
 * یک **Zustand Store** برای مدیریت وضعیت حساب کاربری.
 * این استور شامل موجودی نقدی، موجودی اعتباری و کارت‌های مرتبط با کاربر است.
 *
 * ویژگی‌ها:
 * - balance: موجودی نقدی کاربر
 * - credit: موجودی اعتباری و جزئیات اعتباری
 * - cards: لیست کارت‌های کاربر
 * - setAccountData: تابعی برای بروزرسانی تمامی داده‌های حساب
 *
 * مثال استفاده:
 * const { balance, credit, cards, setAccountData } = useAccountStore();
 *
 * جزئیات هر فیلد:
 * - balance: موجودی نقدی کاربر (عدد)
 * - credit: اطلاعات مربوط به اعتبارات کاربر شامل:
 *   - balance: موجودی اعتباری
 *   - expire: تاریخ انقضا اعتبار
 *   - amount: مقدار اعتبار
 *   - totalDebt: کل بدهی
 * - cards: آرایه‌ای از کارت‌های کاربر که هر کارت شامل:
 *   - id: شناسه کارت
 *   - user: شناسه کاربر
 *   - number: شماره کارت
 *   - cvv: کد CVV
 *   - expire: تاریخ انقضا کارت
 *   - password: رمز کارت (در صورت وجود)
 *   - ts: زمان ایجاد کارت
 *   - updated_at: زمان آخرین بروزرسانی
 * - setAccountData(data): تابعی که کل داده‌های حساب (موجودی، اعتبارات و کارت‌ها) را بروزرسانی می‌کند.
 */

export const useRoleStore = create<RoleStore>((set) => {
  let initialRole: Role = "user";

  if (typeof window !== "undefined") {
    const storedRole = localStorage.getItem("roleEnter");
    if (storedRole) initialRole = storedRole;
  }

  return {
    role: initialRole,
    setRole: (role) => {
      localStorage.setItem("roleEnter", role || ""); // اختیاری: ذخیره خودکار
      set({ role });
    },
  };
});
